import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "../pages/homePage/homePage";
import TutorialPage from "../pages/tutorialPage/tutorialPage";
import SetupPage from "../pages/setupPage/setupPage";
import LoginPage from "../pages/loginPage/loginPage";
import DataProtectionPage from "../pages/dataProtectionPage/dataProtectionPage";
import AgeSelectionPage from "../pages/ageSelectionPage/ageSelectionPage";
import SbGamePage from "../pages/sbgamePage/sbgamePage";
import FactCheckerPage from "../pages/sbgamePage/factChecker/factCheckerPage";
import Survey from "../pages/survey/survey";
import TopicSelectionPage from "../pages/topicSelectionPage/topicSelectionPage";
import CurrentNews from "../pages/currentNews/currentNews";
import Rethinking from "../pages/rethinking/rethinking";
import ProfilePage from "../pages/profilePage/profilePage";
import Finish from "../pages/finish/finish";
import StatisticsPage from "../pages/statisticsPage/statisticsPage";
import ExplanationPage from "../pages/explanationPage/explanationPage";
import DashboardPage from "../pages/statisticsPage/dahboardPage";
import MysteryLogin from "../pages/mysteryLogin/mysteryLogin";
import InitialSettingsTeen from "../pages/initialSettingsTeen/initialSettingsTeen";
import Contacts from "../pages/contacts/contacts";
import GameModeSelector from "../pages/gameModeSelector/gameModeSelector";
import IllustrationGame from "../pages/illustrationGame/illustrationGame";

// import MysteryPdf from "../pages/mysteryLogin/mysteryPdf";

// import ALLNews from "../pages/currentNews/NewsAllCheck";

function AppRouter() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/home" element={<SetupPage />} />
        <Route path="/tutorial" element={<TutorialPage />} />
        <Route path="/login" element={<LoginPage />} />

        <Route path="/explanation" element={<ExplanationPage />} />
        <Route path="/data" element={<DataProtectionPage />} />
        <Route path="/age" element={<AgeSelectionPage />} />
        <Route path="/social" element={<SbGamePage />} />
        <Route path="/social/:type" element={<FactCheckerPage />} />
        
        <Route path="/statistics" element={<StatisticsPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/topics" element={<TopicSelectionPage />} />
        <Route path="/news" element={<CurrentNews />} />
        <Route path="/rethinking" element={<Rethinking />} />
        <Route path="/profile" element={<ProfilePage />} />

        <Route path="/survey/:type" element={<Survey />} />
        <Route path="/finish" element={<Finish />} />

        <Route path="/mystery" element={<MysteryLogin />} />
        <Route path="/settings" element={<InitialSettingsTeen />} />
        <Route path="/contacts" element={<Contacts />} />
        <Route path="/mode-selector" element={<GameModeSelector />} />
        <Route path="/story" element={<IllustrationGame />} />

        {/* <Route path="/all_news_admin" element={<ALLNews />} /> */}
      </Routes>
    </Router>
  );
}

export default AppRouter;
